import { gql } from "@apollo/client";
import { useQueryCoordinate, useMutationCoordinate } from "../graphql.hooks";

export const LIST_NOTIFICATION_TEMPLATES = gql`
  query ListNotificationTemplates {
    listNotificationTemplates {
      notificationTemplateKey
      type
      subject
      body
      deliveryMethod
      createdAt
    }
  }
`;

export const LIST_NOTIFICATION_CAMPAIGNS = gql`
  query ListNotificationCampaigns($notificationTemplateKey: Int!) {
    listNotificationCampaigns(
      notificationTemplateKey: $notificationTemplateKey
    ) {
      notificationKey
      notificationTemplateKey
      targetMode
      targetDefinition
      scheduledAt
      endAt
      totalRecipients
      sentCount
      ackedCount
      createdAt
      subject
      body
      createdByUserKey
    }
  }
`;

export const LIST_CUSTOM_NOTIFICATION_CAMPAIGNS = gql`
  query ListCustomNotificationCampaigns($limit: Int, $offset: Int) {
    listCustomNotificationCampaigns(limit: $limit, offset: $offset) {
      notificationKey
      targetMode
      targetDefinition
      scheduledAt
      endAt
      totalRecipients
      sentCount
      ackedCount
      createdAt
      subject
      body
    }
  }
`;

export const GET_NOTIFICATION_CAMPAIGN_DETAILS = gql`
  query GetNotificationCampaignDetails($notificationKey: Int!) {
    getNotificationCampaignDetails(notificationKey: $notificationKey) {
      notification {
        notificationKey
        notificationTemplateKey
        targetMode
        targetDefinition
        scheduledAt
        endAt
        totalRecipients
        sentCount
        ackedCount
        createdAt
        subject
        body
      }
      recipients {
        notificationKey
        userKey
        firstName
        lastName
        email
        deliveryStatus
        ackedAt
        sentAt
        createdAt
      }
    }
  }
`;

export const GET_NOTIFICATION_RECIPIENT_DETAILS = gql`
  query GetNotificationRecipientDetails($notificationKey: Int!) {
    getNotificationRecipientDetails(notificationKey: $notificationKey) {
      recipient {
        notificationKey
        userKey
        firstName
        lastName
        email
        deliveryStatus
        ackedAt
        sentAt
        createdAt
      }
      deliveryLogs {
        notificationDeliveryLogKey
        responsePayload
        attemptNumber
        createdAt
      }
    }
  }
`;

export const GET_TARGET_DEFINITION_TYPES = gql`
  query GetTargetDefinitionTypes($notificationTemplateKey: Int!) {
    getTargetDefinitionTypes(
      notificationTemplateKey: $notificationTemplateKey
    ) {
      defaultTargetMode
      targetDefinitionSchema
    }
  }
`;

export const CREATE_NOTIFICATION_CAMPAIGN = gql`
  mutation CreateNotificationCampaign(
    $input: CreateNotificationCampaignInput!
  ) {
    createNotificationCampaign(input: $input) {
      success
    }
  }
`;

export const useListNotificationTemplates = (options = {}) => {
  return useQueryCoordinate(LIST_NOTIFICATION_TEMPLATES, options);
};

export const useListNotificationCampaigns = (
  notificationTemplateKey: number,
  options = {}
) => {
  return useQueryCoordinate(LIST_NOTIFICATION_CAMPAIGNS, {
    variables: { notificationTemplateKey },
    ...options,
  });
};

export const useListCustomNotificationCampaigns = (
  limit = 20,
  offset = 0,
  options = {}
) => {
  return useQueryCoordinate(LIST_CUSTOM_NOTIFICATION_CAMPAIGNS, {
    variables: { limit, offset },
    ...options,
  });
};

export const useGetNotificationCampaignDetails = (
  notificationKey: number,
  options = {}
) => {
  return useQueryCoordinate(GET_NOTIFICATION_CAMPAIGN_DETAILS, {
    variables: { notificationKey },
    ...options,
  });
};

export const useGetNotificationRecipientDetails = (
  notificationKey: number,
  options = {}
) => {
  return useQueryCoordinate(GET_NOTIFICATION_RECIPIENT_DETAILS, {
    variables: { notificationKey },
    ...options,
  });
};

export const useGetTargetDefinitionTypes = (
  notificationTemplateKey: number,
  options = {}
) => {
  return useQueryCoordinate(GET_TARGET_DEFINITION_TYPES, {
    variables: { notificationTemplateKey },
    ...options,
  });
};

export const useCreateNotificationCampaign = (options = {}) => {
  return useMutationCoordinate(CREATE_NOTIFICATION_CAMPAIGN, options);
};
